/// <reference path="../../typings/browser.d.ts" />
/// <reference path="../../customtypings/jquery.flot/jquery.flot.d.ts" />
/// <reference path="../../customtypings/chart.js/index.d.ts" />

namespace Application.Directives {
    'use strict';

    import IPlotPoint = Application.Models.IPlotPoint;
    import UserService = Application.Services.UserService;
    import TimezoneService = Application.Services.TimezoneService;
    import MONOTONOUS_TYPE = Models.MONOTONOUS_TYPE;
    declare type EurovisionGraphDirectiveCb = ($interval: angular.IIntervalService, userService: UserService, timezoneService: TimezoneService) => EurovisionGraphDirective;

    const CONTINUOUS_MOVEMENT_INTERVAL: number = 100;
    const DEBUG_CONTINUOUS_MOVEMENT: boolean = false;


    /**
     * Custom scope
     */
    export interface IEurovisionGraphDirectiveScopeDef {
        id: string;
        style: string;
        series: string;
        options: string;
        theme: string;
        width: string;
        height: string;
        lastValues: string;
        maxSeconds: string;
    }

    interface IHumanBits {
        unit: string;
        value: number;
    }

    interface DataXY {
        x: number;
        y: number;
    }

    export interface IEurovisionGraphDirectiveScope extends ng.IScope {
        id: string;
        style: string;
        series: string[][];
        lastValues: string[];
        maxSeconds: number;
        labels: any[];
        min: any;
        data: any[][];
        options: Chart.ChartOptions;
        seriesStatus: boolean[];
        firstLoad: boolean;
        datasetOverride: any;
        processedSeries: Array<jquery.flot.dataSeries>;
        theme: string;
        width: string;
        colors: any;
        height: string;
        dataUnit: string;
        recalcDataUnit: boolean;
        onHover: (event: JQueryEventObject, pos: jquery.flot.pos, item: jquery.flot.item) => void;
        cleanOldValues: () => void;
        backgroundColor: string;
        futurePoints: IPlotPoint[][];
        previousPoints: IPlotPoint[][];
        previousTimes: number[];
        monotonousType: MONOTONOUS_TYPE[];
        timeLimit: number;
        isAdmin: boolean;
    }


    export class EurovisionGraphDirective implements ng.IDirective {


        public static $name: string = "eurovisionGraph";
        public static $inject: string[] = [];

        private static COOKIE_THRESHOLD_VALUE_KEY: string = 'flex_threshold_value_stream_';
        private static COOKIE_THRESHOLD_ENABLED_KEY: string = 'flex_threshold_enabled_stream_';
        public restrict: string = 'E';
        public transclude: boolean = false;
        public templateUrl: string = 'decorators/eurovision-graph-directive.html';
        public scope: IEurovisionGraphDirectiveScopeDef = {
            id: '@',
            style: '@',
            series: '=',
            options: '=?',
            theme: '@',
            width: '@',
            height: '@',
            lastValues: '=',
            maxSeconds: '@',
        };

        public link: (scope: IEurovisionGraphDirectiveScope, element: JQuery, attrs: ng.IAttributes) => void;
        private continuousMovement: boolean = false;
        private futurePointsTimer: ng.IPromise<void>;
        private interpolate: Models.Interpolate = new Models.Interpolate(undefined);
        private plotOptions: Chart.ChartOptions = {};
        private userTimezone: string;


        public static Factory(): EurovisionGraphDirectiveCb {
            const eurovisionGraphDirective = ($interval: angular.IIntervalService, userService: UserService, timezoneservice: TimezoneService) => {
                return new EurovisionGraphDirective($interval, userService, timezoneservice);
            };
            eurovisionGraphDirective.$inject = ['$interval', 'userService', 'timezoneService'];
            return eurovisionGraphDirective;
        }

        constructor(private $interval: angular.IIntervalService, private userService: UserService, private timezoneService: TimezoneService) {
            // TODO: fix height when many charts are refreshing
            let firstTimeMarginRefresh: boolean = true;
            EurovisionGraphDirective.prototype.link = (scope: IEurovisionGraphDirectiveScope, element: JQuery, attrs: ng.IAttributes) => {
                Chart.pluginService.register({
                    beforeDraw: function (chart: any) {
                        const ctx = chart.chart.ctx;
                        const chartArea = chart.chartArea;
                        ctx.fillStyle = 'rgb(51, 51, 51)';
                        ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                        if (firstTimeMarginRefresh) {
                            firstTimeMarginRefresh = false;
                            if (scope.theme === 'streamDetails') {
                                // We calculate the diference between canvas heigth and graphArea height
                                const div: HTMLElement = document.getElementById("thumbnail-streamdetails");
                                if (div) {
                                    const heightDiff: number = chart.height - chart.boxes[3].height;
                                    div.style.marginBottom = heightDiff + 'px';
                                }

                            }
                        }
                    },
                });
                this.userService.loadCurrentUser().then((user: Models.User) => {
                    scope.isAdmin = user.authorities.some((auth: Models.IAuthority) => {
                        return auth.authority === 'ROLE_ADMIN';
                    });
                });
                this.userTimezone = timezoneService.getEffectiveTimezone();
                this.plotOptions = {
                    maintainAspectRatio: scope.theme === 'streamDetails' ? false : true,
                    responsive: true,
                    responsiveAnimationDuration: 0,
                    layout: {},
                    animation: {
                        duration: 0,
                    },
                    elements: {
                        line: {
                            borderWidth: 2,
                        },
                        point: {
                            radius: 0,
                        },
                    },
                    legend: {
                        display: false,
                    },
                    scales: {
                        xAxes: [{
                            bounds: 'data',
                            ticks: {
                                callback: (value: string) => {
                                    return moment(value, "h:mm:ss A").utc().tz(this.userTimezone).format("HH:mm");
                                },
                                maxRotation: 0,
                                minRotation: 0,
                                fontColor: '#000',
                                beginAtZero: false,
                                padding: 5,
                            },
                            type: 'time',
                            time: {
                                unit: 'minute',
                                stepSize: 1,
                            },
                            gridLines: {
                                display: true,
                                drawBorder: true,
                                drawTicks: false,
                                color: scope.theme === 'streamDetails' ? 'rgba(233,233,233,0.7)' : '#6c6c6c',
                            },
                        }],
                        yAxes: [{
                            afterDataLimits: (data: any) => {
                                data.max *= 1.2;
                            },
                            position: scope.theme === 'streamDetails' ? 'right' : 'left',
                            ticks: {

                                callback: function (value: any) {
                                    if (scope.theme === 'streamDetails') {
                                        return '  ' + value;
                                    }
                                    return value + '  ';
                                },
                                autoSkip: true,
                                min: 0,
                                fontColor: '#000',
                                lineHeight: 0.5,
                                maxTicksLimit: 9,
                            },
                            gridLines: {
                                drawBorder: true,
                                display: true,
                                drawTicks: false,
                                color: scope.theme === 'streamDetails' ? 'rgba(233,233,233,0.7)' : '#6c6c6c'
                            },
                        }],
                    },
                    tooltips: {
                        enabled: false,
                    },
                };

                scope.options = { ...this.plotOptions, ...scope.options };
                scope.data = [];
                scope.seriesStatus = [];
                scope.colors = [];
                scope.futurePoints = [];
                scope.datasetOverride = [{
                    cubicInterpolationMode: 'monotone',
                }];

                scope.$on('$destroy', () => {
                    if (this.futurePointsTimer) {
                        this.$interval.cancel(this.futurePointsTimer);
                        this.futurePointsTimer = undefined;
                    }

                    scope.data = [];
                    scope.previousPoints = [];
                    scope.colors = [];
                    scope.seriesStatus = [];
                    scope.futurePoints = [];
                });

                if (!scope.height)
                    scope.height = "85";

                this.continuousMovement = scope.theme === "streamDetails";

                scope.cleanOldValues = () => {
                    let maxMilliseconds: number = scope.maxSeconds ? (scope.maxSeconds - 5) * 1000 : 90000;
                    if (this.continuousMovement) {
                        maxMilliseconds = maxMilliseconds - 5000; // We remove a 5 sec point in continuous movement
                    }
                    let min: number = Date.now().valueOf();
                    let max: number = 0;
                    scope.data.forEach((series: DataXY[]) => {
                        if (series.length > 0) {
                            // console.log("Series diff = " + (series[series.length - 1].x-series[0].x));
                            while (series[series.length - 1] && series[series.length - 1].x - series[0].x > maxMilliseconds) {
                                series.splice(0, 1);
                            }
                            if (series[0].x < min) min = series[0].x;
                            if (series[series.length - 1].x > max) max = series[series.length - 1].x
                        }
                    });
                    if (max - min > maxMilliseconds) {
                        const newMin: number = max - maxMilliseconds;
                        // console.log("Max-min greater than max seconds, pruning " + newMin + "ms");
                        scope.data.forEach((series: DataXY[], index: number) => {
                            if (!series || series.length === 0) {
                                return;
                            }
                            // console.log("MultiSeriesTrimmer: ", series[0].x, newMin);
                            while (series[0] && series[0].x < newMin) {
                                series.splice(0, 1);
                            }
                        });
                    } else {
                        // console.log("No pruning because diff is " + (max - min));
                    }
                };

                scope.$watchCollection('series', (seriesSet: IPlotPoint[][]) => {
                    if (seriesSet && seriesSet.length > 0 && seriesSet[0] && seriesSet[0].length > 0) {
                        scope.firstLoad = true;
                        scope.futurePoints = [];
                        scope.previousPoints = [];
                        scope.previousTimes = [];
                        scope.monotonousType = [];
                        scope.data = [];
                        scope.colors = [];
                        scope.datasetOverride = [];
                        seriesSet.forEach((series: IPlotPoint[], index: number) => {
                            scope.seriesStatus.push(true);
                            scope.futurePoints.push([]);
                            scope.previousPoints.push([]);
                            scope.previousTimes.push(0);
                            scope.monotonousType.push("EQUALS");
                            const seriesPreviousPoints: IPlotPoint[] = scope.previousPoints[index];
                            const seriesFuturePoints: IPlotPoint[] = scope.futurePoints[index];
                            scope.data.push([]);
                            scope.data.push([]);
                            this.applyColorsByTheme(index, scope);
                            if (series) {
                                const seriesData = scope.data[index * 2];
                                series.forEach((point: IPlotPoint, pointIndex: number) => {
                                    if (!this.continuousMovement) {
                                        seriesData.push({ x: point.time, y: point.value });
                                    } else {
                                        if (pointIndex < series.length - 1) {
                                            if (point.synthetic && point.value !== null) {
                                                if (DEBUG_CONTINUOUS_MOVEMENT)
                                                    console.log("Changing point to no synthetic");
                                                point.synthetic = false;
                                            }

                                            if (pointIndex !== 0) {
                                                this.interpolateBetween(point, series, pointIndex, seriesData);
                                            }
                                            seriesData.push({ x: point.time, y: point.value });
                                            this.addToPreviousPoints(seriesPreviousPoints, point);
                                        } else {
                                            const elapsedToNextPoint: number = point.time - seriesData[seriesData.length - 1].x;
                                            const timeMinutes = moment(point.time).get('minutes');
                                            const timeSeconds = moment(point.time).get('seconds');
                                            let nowMinutes: number = moment().get('minutes');
                                            let nowSeconds: number = moment().get('seconds');
                                            if (nowMinutes === 0 && timeMinutes !== 0) { // If time close to hh:59:59
                                                const minutesOffset: number = nowMinutes + 60 - timeMinutes;
                                                nowMinutes = timeMinutes;
                                                nowSeconds += minutesOffset * 60;
                                            }
                                            let offSet: number = 1000 * ((nowMinutes * 60 + nowSeconds) - (timeMinutes * 60 + timeSeconds));
                                            point.time += offSet;
                                            scope.previousTimes[index] += offSet;
                                            // console.log("Offset is ", offSet);
                                            scope.timeLimit = new Date().getTime() + elapsedToNextPoint;
                                            seriesFuturePoints.push(point);
                                            this.initFuturePointsTimer(scope);
                                            return;
                                        }
                                    }
                                    scope.previousTimes[index] = seriesData[seriesData.length - 1].x;
                                });
                            }
                        });
                    }

                    if (scope.theme === 'multiviewer')
                        scope.backgroundColor = "rgb(211, 211, 211)";
                    else
                        scope.backgroundColor = "rgb(255, 255, 255)";
                });

                scope.$watchCollection('lastValues', (points: IPlotPoint[], oldPoints: IPlotPoint[]) => {
                    if (points) {
                        points.forEach((point: IPlotPoint, index: number) => {
                            if (point) {
                                if (point.time < scope.previousTimes[index]) {
                                    if (DEBUG_CONTINUOUS_MOVEMENT)
                                        console.log("Got a point that is not new, ignoring it", point);
                                    return;
                                }
                                if (!oldPoints || oldPoints[index] !== point) {
                                    // console.log("Last valid point in series: " + index, point);
                                    if (!scope.isAdmin) {
                                        point.synthetic = false;
                                    }
                                    if (scope.seriesStatus.length > 0) {
                                        if (this.continuousMovement) {
                                            const seriesFuturePoints = scope.futurePoints[index];
                                            if (seriesFuturePoints.length === 0 ||
                                                point.time > seriesFuturePoints[seriesFuturePoints.length - 1].time) {
                                                seriesFuturePoints.push(point);
                                                // console.log(`*[${new Date().toJSON()}] New Target point time is ${point.time} synthetic: ${point.synthetic} Future queue size: ${seriesFuturePoints.length}`);
                                                this.initFuturePointsTimer(scope);
                                            }
                                        } else {
                                            this.doAddPoint(scope, point, index);
                                        }
                                    }
                                }
                            }
                        });
                    }
                    scope.cleanOldValues();
                });
            };
        }

        /**
         * This set the colors and styles for each lines of the graph. Style depends of the theme selected and the index number,
         * Theme with defined styles are switch, digicon,...
         * */
        private applyColorsByTheme(index: number, scope: IEurovisionGraphDirectiveScope): void {
            if (scope.theme === 'switch') {
                if (index === 0) {
                    scope.colors.push({
                        backgroundColor: 'rgb(255, 255, 255, 1)',
                        borderColor: 'rgb(255, 255, 255, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(208, 208, 208, 1)',
                        borderColor: 'rgb(208, 208, 208, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                } else {
                    scope.colors.push({
                        backgroundColor: 'rgb(123, 11, 222, 1)',
                        borderColor: 'rgb(143, 11, 222, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(32, 13, 38, 1)',
                        borderColor: 'rgb(63, 13, 38, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 5,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                }
            } else if (scope.theme === 'digicon') {
                if (index === 0) {
                    scope.colors.push({
                        backgroundColor: 'rgb(255, 255, 255, 1)',
                        borderColor: 'rgb(255, 255, 255, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(208, 208, 208, 1)',
                        borderColor: 'rgb(208, 208, 208, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                } else if (index === 1) {
                    scope.colors.push({
                        backgroundColor: 'rgb(201, 164, 238, 1)',
                        borderColor: 'rgb(201, 164, 238)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(32, 13, 38, 1)',
                        borderColor: 'rgb(63, 13, 38, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });

                }  else if (index === 2) {
                    scope.colors.push({
                        backgroundColor: 'rgb(238, 238, 156, 1)',
                        borderColor: 'rgb(238, 238, 156, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(208, 208, 208, 1)',
                        borderColor: 'rgb(208, 208, 208, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });

                } else if (index === 3) {
                    scope.colors.push({
                        backgroundColor: 'rgb(156, 238, 238, 1)',
                        borderColor: 'rgb(156, 238, 238, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(208, 208, 208, 1)',
                        borderColor: 'rgb(208, 208, 208, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                }
                else if (index === 4) {
                    scope.colors.push({
                        backgroundColor: 'rgb(117, 116, 250, 1)',
                        borderColor: 'rgb(117, 116, 250, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(117, 116, 250, 1)',
                        borderColor: 'rgb(117, 116, 250, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                }
                else if (index === 5) {
                    scope.colors.push({
                        backgroundColor: 'rgb(242, 97, 96, 1)',
                        borderColor: 'rgb(242, 97, 96, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(242, 97, 96, 1)',
                        borderColor: 'rgb(242, 97, 96, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                }
                else {
                    scope.colors.push({
                        backgroundColor: 'rgb(238, 238, 156, 1)',
                        borderColor: 'rgb(238, 238, 156, 1)',
                    });
                    scope.colors.push({
                        backgroundColor: 'rgb(32, 13, 38, 1)',
                        borderColor: 'rgb(63, 13, 38, 1)',
                    });
                    scope.datasetOverride.push({
                        borderWidth: 2,
                    });
                    scope.datasetOverride.push({
                        borderWidth: 0,
                    });
                }
            } else {
                const red: number = 54 + 40 * index;
                const green: number = 121 + 20 * index;
                const blue: number = 83 + 200 * index;
                scope.colors.push({
                    backgroundColor: `rgb(${red}, ${green}, ${blue}, 0.5)`,
                    borderColor: `rgb(${red - 20}, ${green + 20}, ${blue}, 1)`,
                });
                scope.colors.push({
                    backgroundColor: `rgb(${red}, ${green}, ${blue}, 0.5)`,
                    borderColor: `rgb(${red}, ${green}, ${blue}, 0.5)`,
                });
                if (index % 2 === 0) {
                    scope.datasetOverride.push({ fill: true });
                    scope.datasetOverride.push({ fill: true });
                } else {
                    scope.datasetOverride.push({ fill: false });
                    scope.datasetOverride.push({ fill: false });
                }
            }
        }

        private initFuturePointsTimer(scope: IEurovisionGraphDirectiveScope): void {
            if (this.futurePointsTimer === undefined) {
                this.futurePointsTimer = this.$interval(() => {
                    scope.futurePoints.forEach((futurePointsSeries: IPlotPoint[], index: number) => {
                        this.interpolateSeries(scope, futurePointsSeries, index);
                    });
                    scope.cleanOldValues();
                }, CONTINUOUS_MOVEMENT_INTERVAL);
            }
        }

        private interpolateSeries(scope: IEurovisionGraphDirectiveScope, futurePointsSeries: IPlotPoint[], index: number) {
            const seriesPreviousPoints = scope.previousPoints[index];
            const futureSize = futurePointsSeries.length;
            if (futureSize > 0) {
                const targetPoint: IPlotPoint = futurePointsSeries[0];
                const previousIsSynthetic: boolean = !scope.seriesStatus[index];
                const lastTime: number = scope.previousTimes[index];
                const now: number = new Date().getTime();
                if ((futurePointsSeries.length > 1 && now > scope.timeLimit)
                    || targetPoint.time < lastTime + (CONTINUOUS_MOVEMENT_INTERVAL * 1.2)) {
                    let delay: number = now - targetPoint.time;
                    if (DEBUG_CONTINUOUS_MOVEMENT)
                        console.log("Delay with actual time: " + delay + ". Queue size " + futurePointsSeries.length);
                    this.doAddPoint(scope, targetPoint, index);
                    futurePointsSeries.splice(0, 1);
                    const nextPointValue = futurePointsSeries[0] ? futurePointsSeries[0].value : targetPoint.value;
                    scope.monotonousType[index] = this.getMonotonousType(targetPoint.value, nextPointValue);
                    this.addToPreviousPoints(seriesPreviousPoints, targetPoint);
                    let previousActualPoint = targetPoint;
                    while (delay > 6500 && futurePointsSeries.length > 1) {
                        console.log("Plotting additional future points!");
                        let myLastTime: number = scope.previousTimes[index];
                        const additionalPoint: IPlotPoint = futurePointsSeries[0];
                        const nextPointValue2 = additionalPoint ? additionalPoint.value : previousActualPoint.value;
                        scope.monotonousType[index] = this.getMonotonousType(previousActualPoint.value, nextPointValue2);
                        while (additionalPoint.time >= myLastTime + (CONTINUOUS_MOVEMENT_INTERVAL * 1.3)) {
                            this.interpolateOnePoint(myLastTime, seriesPreviousPoints, futurePointsSeries, false, scope, index);
                            myLastTime = scope.previousTimes[index];
                        }
                        this.doAddPoint(scope, additionalPoint, index);
                        futurePointsSeries.splice(0, 1);
                        previousActualPoint = additionalPoint;
                        this.addToPreviousPoints(seriesPreviousPoints, additionalPoint);
                        delay = new Date().getTime() - additionalPoint.time;
                    }
                    if (DEBUG_CONTINUOUS_MOVEMENT)
                        console.log("leaving delay at " + delay + " queue at " + futurePointsSeries.length);
                    if (futurePointsSeries[0]) {
                        const elapsedToNextPoint: number = futurePointsSeries[0].time - targetPoint.time;
                        scope.timeLimit = now + elapsedToNextPoint;
                    } else {
                        scope.timeLimit = Number.MAX_VALUE;
                    }
                    if (DEBUG_CONTINUOUS_MOVEMENT)
                        console.log("-----");
                } else {
                    this.interpolateOnePoint(lastTime, seriesPreviousPoints, futurePointsSeries, previousIsSynthetic, scope, index);
                }
            } else {
                if (DEBUG_CONTINUOUS_MOVEMENT)
                    console.log("Empty queue!!!");
                const synthetic: boolean = !scope.seriesStatus[index];
                const lastTime: number = scope.previousTimes[index];
                const seriesIndex: number = synthetic ? index * 2 + 1 : index * 2;
                const lastValue: number = scope.data[seriesIndex][scope.data[seriesIndex].length - 1].y;

                const emptyQueueTime: number = lastTime + (CONTINUOUS_MOVEMENT_INTERVAL / 2);
                this.doAddPoint(scope, {
                    time: emptyQueueTime,
                    value: lastValue,
                    synthetic: synthetic,
                }, index);

                this.addToPreviousPoints(seriesPreviousPoints, {
                    time: emptyQueueTime,
                    value: lastValue,
                    synthetic: synthetic,
                });

            }
        }

        private getMonotonousType(previousPointValue: number, nextPointValue: number): MONOTONOUS_TYPE {
            return nextPointValue >= previousPointValue ? (nextPointValue > previousPointValue ? "INCREASING" : "EQUALS") : "DECREASING";
        }

        private interpolateOnePoint(lastTime: number, seriesPreviousPoints: IPlotPoint[], nextPoints: IPlotPoint[],
            previousIsSynthetic: boolean, scope: IEurovisionGraphDirectiveScope, index: number) {
            const newX: number = lastTime + CONTINUOUS_MOVEMENT_INTERVAL;
            let newY: number = null;
            if (seriesPreviousPoints.length > 0) {
                const latestValue: number = seriesPreviousPoints[seriesPreviousPoints.length - 1].value;
                const pointXs: number[] = latestValue !== null ? seriesPreviousPoints.filter((value) => { return (value.value !== null && value.value !== undefined) }).map(value => value.time) : [];
                const pointYs: number[] = latestValue !== null ? seriesPreviousPoints.filter((value) => { return (value.value !== null && value.value !== undefined) }).map(value => value.value) : [];
                nextPoints.forEach((nextPoint: IPlotPoint) => {
                    if (nextPoint.value !== null && nextPoint.value !== undefined) {
                        pointXs.push(nextPoint.time);
                        pointYs.push(nextPoint.value);
                    }
                });
                if (pointXs.length > 0 && pointXs[pointXs.length - 1] > newX) {
                    newY = this.interpolate.spline(newX, pointXs, pointYs, scope.monotonousType[index]);
                } else {
                    // If target point it is a null (no data) we continue with the latest value until we reach the null
                    newY = latestValue;
                }
            }

            const interpolationPoint: IPlotPoint = {
                time: newX,
                value: newY,
                synthetic: previousIsSynthetic,
            };
            this.doAddPoint(scope, interpolationPoint, index);
            this.addToPreviousPoints(seriesPreviousPoints, interpolationPoint);
        }

        private addToPreviousPoints(seriesPreviousPoints: IPlotPoint[], targetPoint: IPlotPoint) {
            if (targetPoint.value !== null) {
                seriesPreviousPoints.push(targetPoint);
                if (seriesPreviousPoints.length > 15)
                    seriesPreviousPoints.splice(0, 1);
            } else {
                seriesPreviousPoints.splice(0);
            }

        }

        private doAddPoint(scope: IEurovisionGraphDirectiveScope, point: IPlotPoint, index: number) {
            // if (point.value < 1) {
            //     console.log("Drawing low point", point);
            // }

            if (!point.synthetic) {
                this.addNewValidPoint(scope, point, index);
            } else {
                //console.log(`[${scope.id}]Synthetic point`);
                this.addNewSyntheticPoint(scope, point, index);
            }
            scope.previousTimes[index] = point.time;
            scope.cleanOldValues();
        }

        private interpolateBetween(point: IPlotPoint, series: IPlotPoint[], pointIndex: number, seriesData: any[]) {
            const xs = [];
            const ys = [];
            if (pointIndex > 1) {
                const previous2: IPlotPoint = series[pointIndex - 2];
                xs.push(previous2.time);
                ys.push(previous2.value);
            }
            const previous: IPlotPoint = series[pointIndex - 1];
            const monotonousType: MONOTONOUS_TYPE = this.getMonotonousType(previous.value, point.value);
            xs.push(previous.time);
            ys.push(previous.value);
            xs.push(point.time);
            ys.push(point.value);
            if (pointIndex < series.length - 1) {
                xs.push(series[pointIndex + 1].time);
                ys.push(series[pointIndex + 1].value);
            }


            let currentInterTime: number = previous.time + CONTINUOUS_MOVEMENT_INTERVAL;
            while (currentInterTime < point.time) {
                if (previous.value === null || point.value === null) {
                    seriesData.push({ x: currentInterTime, y: null });
                } else {
                    let interpolatedY: number = seriesData[seriesData.length - 1].y; //If target is null, continue last value till null
                    interpolatedY = this.interpolate.spline(currentInterTime, xs, ys, monotonousType);
                    seriesData.push({ x: currentInterTime, y: interpolatedY });
                }
                currentInterTime = currentInterTime + CONTINUOUS_MOVEMENT_INTERVAL;
            }
        }

        private addNewSyntheticPoint(scope: IEurovisionGraphDirectiveScope, point: Models.IPlotPoint, index: number) {
            const seriesIndex: number = index * 2;
            if (scope.seriesStatus[index] && scope.data[seriesIndex] && scope.data[seriesIndex].length > 0) {
                const lastValidaPoint: any = scope.data[seriesIndex][scope.data[seriesIndex].length - 1];
                const lastValidValue: number = lastValidaPoint.y;
                scope.data[seriesIndex].push({ x: point.time - 1, y: lastValidValue });
                scope.data[seriesIndex].push({ x: point.time, y: null });
                scope.data[seriesIndex + 1].push({ x: point.time, y: point.value });
            } else {
                scope.data[seriesIndex + 1].push({ x: point.time, y: point.value });
                scope.data[seriesIndex].push({ x: point.time, y: null });
            }
            scope.seriesStatus[index] = false;
        }

        private addNewValidPoint(scope: Application.Directives.IEurovisionGraphDirectiveScope, point: Application.Models.IPlotPoint, index: number) {
            const seriesIndex = index * 2;
            if (!scope.seriesStatus[index] && scope.data[seriesIndex + 1] && scope.data[seriesIndex + 1].length > 0) {
                const lastSynthPoint = scope.data[seriesIndex + 1][scope.data[seriesIndex + 1].length - 1];
                scope.data[seriesIndex + 1].push({ x: point.time - 1, y: lastSynthPoint.y });
                scope.data[seriesIndex + 1].push({ x: point.time, y: null });
                scope.data[seriesIndex].push({ x: point.time, y: point.value });
            } else {
                scope.data[seriesIndex].push({ x: point.time, y: point.value });
            }
            scope.seriesStatus[index] = true;
        }
    }
}



